export const getNotificationDotColor = (title) => {
  const normalizedTitle = String(title || "").trim().toLowerCase();

  if (normalizedTitle === "process reminder") return "#D97706";
  if (normalizedTitle === "admin note added") return "#7C3AED";
  if (normalizedTitle === "ticket status updated") return "#2563EB";
 if (
  normalizedTitle === "process ready" ||
  normalizedTitle === "processes ready"
) {
  return "#16A34A";
}
  if (
    normalizedTitle.includes("new ticket created") ||
    normalizedTitle.includes("new ticket created for equipment") ||
    normalizedTitle.includes("new ticket created for flange")
  ) {
    return "#F97316";
  }

  return "#6B7280";
};
